import * as actionTypes from '../../../constants/actionTypes';

export const listAction = (payload) => (dispatch) =>
  dispatch({ type: actionTypes.LIST, payload });

export const menuAction = (payload) => (dispatch) =>
  dispatch({ type: actionTypes.MENU, payload });

export const navigationAction = (payload) => (dispatch) =>
  dispatch({ type: actionTypes.NAVIGATION, payload });

export const redirectAction =
  (payload, id = false) =>
  (dispatch) =>
    dispatch({ type: actionTypes.REDIRECT, payload, id });

export const loadingBtnAction = (payload) => (dispatch) =>
  dispatch({ type: actionTypes.LOADING_BTN, payload });

export const loadingPageAction = (payload) => (dispatch) =>
  dispatch({ type: actionTypes.LOADING_PAGE, payload });

export const loadingBackdropAction = (payload) => (dispatch) =>
  dispatch({ type: actionTypes.LOADING_BACKDROP, payload });

export const snackbarAction =
  (status = false, message = '') =>
  (dispatch) => {
    dispatch({ type: actionTypes.SNACKBAR, payload: { status, message } });
  };
